import { FaqAccordionItems } from '@app/widgets';

export const COMPARE_IONIC_APPFLOW_FAQS: FaqAccordionItems[] = [
  {
    question: 'Why did Ionic discontinue Appflow for new customers?',
    answer: [
      'Ionic <a href="https://ionic.io/blog/important-announcement-the-future-of-ionics-commercial-products" target="_blank">discontinued</a> all commercial products to refocus on their open-source framework. Existing customers can use Appflow until December 31, 2027, but no new features will be added.',
      'Capawesome Cloud fills this gap with a complete CI/CD platform built by official Ionic Developer Experts.',
    ].join(' '),
  },
  {
    question:
      'How easy is it to migrate from Ionic Appflow to Capawesome Cloud?',
    answer: [
      'Migration is straightforward and typically takes less than a day. Both platforms use similar concepts, making the transition seamless.',
      'Our team provides free migration support with comprehensive documentation and direct assistance.',
    ].join(' '),
  },
  {
    question: "How do Capawesome Cloud's Native Builds compare to Appflow?",
    answer: [
      "Our builds are 3-5x faster with M4 macOS runners (vs Appflow's M1) and more affordable pricing ($9/month vs $49/month).",
      'You get the same integrations and signing capabilities plus seamless CI/CD with centralized tracking.',
    ].join(' '),
  },
  {
    question:
      'Will I save money by switching from Appflow to Capawesome Cloud?',
    answer: [
      "Yes - we start at $9/month vs Appflow's $49/month, with Live Updates pricing ~10x cheaper (~$0.001 vs ~$0.01 per MAU).",
      'You get more features for less, including 3-5x faster builds, automatic rollbacks, and transparent pricing with no hidden fees.',
    ].join(' '),
  },
  {
    question:
      'What advantages does Capawesome Cloud offer beyond Appflow features?',
    answer: [
      'We offer automatic rollbacks, custom properties, open-source SDK/CLI, EU hosting, 99.99% uptime, and enterprise features like ISO 27001, SSO, and audit logs.',
      'Built by official Ionic Developer Experts with active development and ongoing innovations - unlike Appflow which is in maintenance mode.',
    ].join(' '),
  },
];

export const COMPARE_CAPGO_FAQS: FaqAccordionItems[] = [
  {
    question: 'Why should I migrate from Capgo to Capawesome Cloud?',
    answer: [
      'Capawesome Cloud offers superior reliability (99.99% vs 99.65% uptime), production-ready Native Builds with M4 runners, and features Capgo lacks like Git integration, web console access, and centralized tracking.',
      "Plus, we're significantly more stable (1 vs 48 patch releases in 90 days) with enterprise features like ISO 27001, SSO, and audit logs.",
    ].join(' '),
  },
  {
    question: 'How easy is it to migrate from Capgo to Capawesome Cloud?',
    answer: [
      'Migration is straightforward and typically takes less than a day - just replace the SDK, update your config, and adjust your deployment workflow.',
      'Our team provides free migration support with comprehensive documentation and direct assistance.',
    ].join(' '),
  },
  {
    question: 'What are the main advantages of Capawesome Cloud over Capgo?',
    answer: [
      'Our SDK is 3.4x smaller (294 KB vs 986 KB) with fewer dependencies, production-ready Native Builds with M4 runners and full Git integration, plus web console access, automatic rollbacks, and enterprise features.',
      'Built by official Ionic Developer Experts and Capacitor Community members with the largest plugin portfolio in the ecosystem.',
    ].join(' '),
  },
  {
    question: 'Will I save money by switching from Capgo to Capawesome Cloud?',
    answer: [
      "Yes - we start at $9/month vs Capgo's $14/month, with a free tier and no build multipliers for predictable costs.",
      'You get more features and better reliability for less, including production-ready Native Builds, Git integration, and enterprise security.',
    ].join(' '),
  },
  {
    question: "How does Capawesome Cloud's SDK compare to Capgo's?",
    answer: [
      'Our SDK is 3.4x smaller (294 KB vs 986 KB) with fewer dependencies (2 vs 4-6), resulting in faster builds and fewer conflicts.',
      'We use the MIT license for complete flexibility and follow the proven Ionic Appflow approach for version distribution.',
    ].join(' '),
  },
];
